import moment from 'moment';
import { Link } from 'react-router-dom';
import Text from 'style-guide/Typography/Text';
import Title from 'style-guide/Typography/Title';

export const getEmailTrackingColumns = (setCourseUserData) => [
  {
    title: <Title variant={5}>Notification</Title>,
    dataIndex: 'text',
    key: 'text',
    width: 500,
    render: (_index, item) => (
      <>
        {item.email && (
          <Text variant={3} paragraph>
            To: {item.email}
          </Text>
        )}
        <Text variant={3} paragraph>
          Subject: {item.subject}
        </Text>
        {item?.text && (
          <Text variant={3} paragraph className='mt--16'>
            Text: {item?.text}
          </Text>
        )}
        {item?.url && item?.url?.startsWith('learning-communities/') && (
          <Text variant={3} paragraph className='mt--16'>
            CTA:{' '}
            <Link onClick={() => setCourseUserData({ id: item.url.split('/')[1] }, `/${item.url}`)}>{item.url}</Link>
          </Text>
        )}
      </>
    ),
  },

  {
    title: <Title variant={5}>Status</Title>,
    dataIndex: 'Status',
    key: 'status',
  },
  {
    title: <Title variant={5}>Updated</Title>,
    dataIndex: 'Updated',
    key: 'updated',
    render: (_index, item) => <Text $variant={2}>{moment(item?.updated).fromNow()}</Text>,
  },
];

export const getNotificationsColumns = () => [
  {
    title: <Title variant={5}>Notification</Title>,
    dataIndex: 'text',
    key: 'text',
    render: (text) => (
      <Text variant={3} paragraph>
        {text || 'No notification text'}
      </Text>
    ),
  },
  {
    title: <Title variant={5}>Created</Title>,
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (createdAt) => <Text variant={2}>{createdAt ? moment(createdAt).fromNow() : 'N/A'}</Text>,
  },
];
